/**
 * The song that "Plan a rollout" opens when the screen shows no song (the Posts page of the
 * artist; owner decision 2026-10-12: pick the best song, do not send the artist to a list).
 *
 * 1. The next release: the song with the nearest release day that is today or later.
 * 2. Else the newest release: the song with the latest release day.
 * 3. Else the first song of the list (no song has a release day).
 * 4. No song: null. The caller opens "Add my song".
 *
 * Two songs with the same day: the first in the list wins. The file imports nothing, so every
 * project can use it; the native apps port the rule.
 */
export interface PlanSongCandidate {
  uuid: string;
  /** `YYYY-MM-DD` or an ISO time; null for no release day. */
  releaseDate: string | null;
}

/** `today` is `YYYY-MM-DD` in the time zone of the viewer. Pure. */
export function bestSongToPlan(songs: ReadonlyArray<PlanSongCandidate>, today: string): string | null {
  let next: { uuid: string; day: string } | null = null;
  let newest: { uuid: string; day: string } | null = null;
  for (const song of songs) {
    if (song.releaseDate === null || song.releaseDate.length < 10) {
      continue;
    }
    const day = song.releaseDate.slice(0, 10);
    if (day >= today) {
      if (next === null || day < next.day) {
        next = { uuid: song.uuid, day };
      }
    } else if (newest === null || day > newest.day) {
      newest = { uuid: song.uuid, day };
    }
  }
  if (next !== null) {
    return next.uuid;
  }
  if (newest !== null) {
    return newest.uuid;
  }
  return songs[0]?.uuid ?? null;
}
